import { Item } from 'components/CollabItem/Item'
import { IconButton } from 'components/IconButton/IconButton'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { ReactComponent as PinIcon } from 'assets/icons/pin.svg'
import { ReactComponent as UnpinIcon } from 'assets/icons/unpin.svg'
import ItemStyles from 'components/CollabItem/CollabItem.module.scss'

import { PinControlProps } from './Types'

const PinControl = observer(({ comment }: PinControlProps) => {
  const rootStore = useRootStore()
  const pinned = comment.important

  return (
    <Item.Control tooltipTitle={pinned ? 'Unpin' : 'Pin'}>
      <IconButton
        className={ItemStyles.controlItem}
        onPress={() => rootStore.comments.togglePin(comment.id)}
        icon={pinned ? UnpinIcon : PinIcon}
        data-title={pinned ? 'Unpin' : 'Pin'}
      />
    </Item.Control>
  )
})

export { PinControl }
